import { createContext } from 'react';
import { GameInfo } from '@domain/game.selection/types/game.info';

const GameSelectionContext = createContext<GameInfo | undefined>(undefined);

export default GameSelectionContext;
